import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import UserService from "../services/UserService";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

function PrivateRoute({ component: Component, permissions, ...rest }) {
  const { t } = useTranslation('translations');
  
  const sendUserMsg = () => {
    MySwal.fire({
      position: 'top-start',
      icon: 'error',
      title: t('message.noPermission'),
      text: t('message.register'),
      showConfirmButton: true,
      toast: true,
      timer: 3500,
      });
  };

  return (
    <Route {...rest} render={(props) => {
      const currentUser = UserService.getLoggedInUser()
      
      if(!currentUser) {
        // if no logged in user
        return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
      }
      
      // check if route is restricted by role
      if (permissions && permissions.indexOf(currentUser.permission) === -1) {
      // role not authorised so redirect to home page
      sendUserMsg()
      return <Redirect to={{ pathname: '/'}} />
      } 
      
      // authorised so return component
      return <Component {...props} />
    }} />
  )
}

export default PrivateRoute;
